import React, { useContext, useEffect, useState } from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom'
import './../Styles/Global.scss'
import 'react-input-range/lib/css/index.css'
import { objNameRoles as roles } from '../const/constRoles'
import LoadingLayer from './../Components/Global/LoadingLayer'

import { PrivateRoute } from './PrivateRoute'
import { PublicRoute } from './PublicRoute'
import { AuthContext } from '../Auth/AuthContext'

//PUBLIC COMPONENTS
import { Login } from '../Components/Auth/Login'

//ADMIN COMPONENTS
import Home from '../Components/Admin/Home/Example'

//DASHBOARDS
import DashboardTechnicalWaterTruck from '../Components/DashboardTechnicalWaterTruck/DashboardTechnicalWaterTruck'

//PUBLIC COMPONENTS
import Verification from '../Components/Auth/Verification'
import Error404 from './../Components/Pages/404/Error404'
import PasswordRecovery from '../Components/Auth/Recovery'

//GRAPHQL COMPONENTS
import { useMutation } from '@apollo/client'
import { DECRYPT_TOKEN } from '../graphql/Auth/auth'
import { GET_ALL_USER_PERMISSIONS } from './../graphql/Catalog/Users/user'

import { types } from '../Types/types'
import moduleRoutesGenerator from '../helpers/moduleRoutesGenerator'
import submoduleRoutesGenerator from '../helpers/submoduleRoutesGenerator'
import { LoginRegister } from '../Components/Auth/LoginRegister'
import OrderPermissions from '../Components/OrderPermissions/OrderPermissions'
import DataDeletionRequest from '../Components/Auth/DataDeletionRequest'
import TermsAndConditions from '../Components/Auth/TermsAndConditions'
import PrivacyPolicy from '../Components/Auth/PrivacyPolicy'
import KnowledgeView from '../Components/Knowledge/KnowledgeView'
import { UserProfileMain } from '../Components/Admin/Catalogs/Users/UserProfile/UserProfileMain'
import DashboardMigrants from '../Components/DashboardMigrants/DashboardMigrants'
import DashboardMigrantsUserInfo from '../Components/DashboardMigrants/DashboardMigrantsUserInfo'
import DashboardMigrantsContact from '../Components/DashboardMigrants/DashboardMigrantsContact'

export const AppRouter = () => {
  const { user, dispatch } = useContext(AuthContext)
  const [decryptToken] = useMutation(DECRYPT_TOKEN)
  const [getAllUserPermissions] = useMutation(GET_ALL_USER_PERMISSIONS)
  const [loading, setLoading] = useState(false)
  const token = localStorage.getItem('token')

  useEffect(() => {
    const validateToken = async () => {
      try {
        setLoading(true)
        const { data: tokenData } = await decryptToken({
          variables: {
            token,
          },
        })
        const decoded = tokenData.decryptToken
        const { data: userPermissionsData } = await getAllUserPermissions({
          variables: {
            userID: decoded.id,
          },
        })
        let userPermissions = await userPermissionsData.getAllUserPermissions

        // const modelOld = userPermissions.filter(
        //   (module) => !module.ReportsPowerBIModelOfUserModules
        // );

        // userPermissions = userPermissions.filter(
        //   (module) => !module.ReportsPowerBIModelOfUserModules
        // );

        let newUserPermissions = []
        userPermissions?.map((module) => {
          if (module?.ReportsPowerBIModelOfUserModules.length > 0) {
            module.ReportsPowerBIModelOfUserModules.forEach((report) => {
              let hasSubmodule =
                report?.sub_module_id && report?.sub_module_id !== 0
              let submodule_info = {
                front_label: report?.front_label,
                icon: report?.icon ? report.icon : 'circle',
                name: hasSubmodule
                  ? `${module?.module_info.name}Submodule`
                  : module?.module_info.name,
                relative_link: hasSubmodule
                  ? report?.pathname_module
                  : `/reportPowerBi${report?.pathname_module}`,
              }

              let module_info = hasSubmodule
                ? {
                    ...module?.module_info,
                    name: module?.module_info.name + 'Submodule',
                  }
                : submodule_info
              newUserPermissions.push({
                access_delete: module?.access_delete,
                access_edit: module?.access_edit,
                access_export: module?.access_export,
                access_import: module?.access_import,
                access_read: module?.access_read,
                access_retrieve: module?.access_retrieve,
                id: module?.id,
                id_module: module?.id_module,
                id_submodule: hasSubmodule ? report.sub_module_id : null,
                submodule_info: hasSubmodule ? submodule_info : null,
                module_info,
              })
            })
          } else newUserPermissions.push(module)
        })

        setLoading(false)
        dispatch({
          type: types.login,
          payload: {
            logged: true,
            type_user: decoded.type_user,
            idUser: decoded.id,
            role: decoded.role,
            email: decoded.email,
            avatar: decoded.avatar,
            userPermissions: newUserPermissions,
            phone: decoded?.phone,
            address: decoded?.address,
            name: decoded.name,
            first_name: decoded?.first_name,
            last_name: decoded?.last_name,
            jurisdiction_id: decoded.jurisdiction_id,
            sub_jurisdiction_id: decoded.sub_jurisdiction_id,
            provider_id: decoded?.provider_id,
          },
        })
      } catch (e) {
        setLoading(false)
        localStorage.removeItem('token')
        dispatch({
          type: types.logout,
        })
        return <Redirect to={'/dashboardMigrants'} />
      }
    }
    if (token) {
      validateToken()
      return
    }
    dispatch({
      type: types.logout,
    })
    return <Redirect to="/dashboardMigrants" />
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.logged])

  return (
    <>
      {!loading ? (
        <Router>
          <Switch>
            <PublicRoute
              exact
              path="/dashboardMigrants"
              component={DashboardMigrants}
              isAuth={user.logged}
            />
            <PublicRoute
              exact
              path="/login"
              component={Login}
              isAuth={user.logged}
            />
            <PublicRoute
              exact
              path="/LoginRegister"
              component={LoginRegister}
              isAuth={user.logged}
            />
            <PublicRoute
              exact
              path="/support?"
              component={DataDeletionRequest}
              isAuth={user.logged}
            />
            <PublicRoute
              exact
              path="/support/:token?"
              component={DataDeletionRequest}
              isAuth={user.logged}
            />
            <PublicRoute
              exact
              path="/privacy-policy"
              component={PrivacyPolicy}
              isAuth={user.logged}
            />
            <PublicRoute
              exact
              path="/terms-and-conditions"
              component={TermsAndConditions}
              isAuth={user.logged}
            />
            <PublicRoute
              exact
              path="/recuperar-contraseña"
              component={PasswordRecovery}
              isAuth={user.logged}
            />
            <PublicRoute
              exact
              path="/verificar/usuario/:token?"
              component={Verification}
              isAuth={user.logged}
            />

            <PrivateRoute
              exact
              path="/dashboard"
              component={
                user?.role === roles.chofer_pipas
                  ? DashboardTechnicalWaterTruck
                  : Home
              }
              isAuth={user.logged}
            />
            <PrivateRoute
              exact
              path="/profile"
              component={UserProfileMain}
              isAuth={user.logged}
            />
            <PrivateRoute
              exact
              path="/knowledge"
              component={KnowledgeView}
              isAuth={user.logged}
            />
            <PrivateRoute
              exact
              path="/orderPermissions/:type/:id"
              component={OrderPermissions}
              isAuth={user.logged}
            />
            <PrivateRoute
              exact
              path="/"
              component={
                user?.role === roles.chofer_pipas
                  ? DashboardTechnicalWaterTruck
                  : Home
              }
              isAuth={user.logged}
            />
            <PrivateRoute
              exact
              path="/dashboardMigrants/logged"
              component={DashboardMigrants}
              isAuth={user.logged}
            />
            <PrivateRoute
              exact
              path="/dashboardMigrants/contact"
              component={DashboardMigrantsContact}
              isAuth={user.logged}
            />
            <PrivateRoute
              exact
              path="/dashboardMigrants/logged/user/:initialTab/:id?"
              component={DashboardMigrantsUserInfo}
              isAuth={user.logged}
            />
            {user.userPermissions && user?.role !== 16
              ? user.userPermissions.map((module) => {
                  const {
                    access_read,
                    access_retrieve,
                    access_edit,
                    access_import,
                  } = module
                  if (!module.id_submodule) {
                    return moduleRoutesGenerator(
                      access_read,
                      access_retrieve,
                      access_edit,
                      access_import,
                      module,
                      user.logged,
                      user.role === 2 ? true : false
                    )
                  }
                  return submoduleRoutesGenerator(
                    access_read,
                    access_retrieve,
                    access_edit,
                    access_import,
                    module,
                    user.logged
                  )
                })
              : null}
            {localStorage.getItem('token') && (
              <Route component={Error404} isAuth={false} />
            )}
            {!localStorage.getItem('token') && (
              <PublicRoute path="*" exact component={Error404} isAuth={true} />
            )}
          </Switch>
        </Router>
      ) : (
        <LoadingLayer />
      )}
    </>
  )
}
